const API = {
	DOMAIN: 'gallery-fat.vphotos.cn',
	COMMON_PORXY: '/LOCALAPI',
	SA_SERVER_URL: 'https://sensors.vphotos.cn:8106/sa?project=vphoto_fat'
};
export { API };
